// UserLivestreamBadges.js
import { connect } from 'react-redux';

import UserLivestreamBadges from '../component/UserLivestreamBadges.jsx';

import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { PUBLIC_BADGE_URL_PATH } from '../RemoteConfigKeys.js';

const mapStateToProps = state => {
  return {
    publicBadgeUrlPath: getRemoteConfigData(state, PUBLIC_BADGE_URL_PATH),
    deviceWidth: getOperationData(state, ['device'], 'width'),
  };
};

export default connect(mapStateToProps)(UserLivestreamBadges);
